import { normalize } from 'normalizr';
import * as schema from '../schema';

import * as actionTypes from './actionTypes';
import { axiosProtected } from '../../axios-wizard';



export const getDocumentationFileUserInfos = (state, productSystemId) => {
  if (state.inventory !== undefined && state.inventory.documentationFileUserInfos !== undefined) {
    const x = Object.values(state.inventory.documentationFileUserInfos).filter(x => x.product_system_id === productSystemId);
    return (Array.isArray(x))? x : undefined;
  } else {
    return [];
  }
}

export const getAllDocumentationFileUserInfos = (state) => {
  if (state.inventory !== undefined && state.inventory.documentationFileUserInfos !== undefined) {
    const x = Object.values(state.inventory.documentationFileUserInfos);
    return (Array.isArray(x))? x : undefined;
  } else {
    return [];
  }
}



export const fetchDocumentationFileUserInfosStart = (  ) => {
    return {
        type: actionTypes.FETCH_DOCUMENTATIONFILEUSERINFOS_START
    };
};

export const fetchDocumentationFileUserInfosSuccess = ( files ) => {
    return {
        type: actionTypes.FETCH_DOCUMENTATIONFILEUSERINFOS_SUCCESS,
        values: files
    };
};

export const fetchDocumentationFileUserInfosFailed = () => {
    return {
        type: actionTypes.FETCH_DOCUMENTATIONFILEUSERINFOS_FAILED
    };
};


export const fetchAllDocumentationFileUserInfos = () => {
    const url = '/api/documentation_file_user_infos'


    return dispatch => {
        dispatch( fetchDocumentationFileUserInfosStart() );
        return axiosProtected.get( url )
            .then( response => {
               const normalized = normalize(response.data, { documentation_file_user_infos: schema.arrayOfDocumentationFileUserInfos })
               dispatch(fetchDocumentationFileUserInfosSuccess(normalized));
               return normalized.result.documentation_file_user_infos
            } )
            .catch( error => {
                dispatch(fetchDocumentationFileUserInfosFailed());
            } );
    };
};




export const deleteDocumentationFileUserInfoStart = (  ) => {
    return {
        type: actionTypes.DELETE_DOCUMENTATIONFILEUSERINFOS_START
    };
};

const deleteDocumentationFileUserInfoSuccess = ( documentationFileUserInfoId) => {
    return {
        type: actionTypes.DELETE_DOCUMENTATIONFILEUSERINFOS_SUCCESS,
        documentationFileUserInfoId: documentationFileUserInfoId
    };
};

const deleteDocumentationFileUserInfoInProductSystemSuccess = ( product_system_id) => {
    return {
        type: actionTypes.DELETE_DOCUMENTATIONFILEUSERINFOS_IN_PRODUCTSYSTEM_SUCCESS,
        product_system_id: product_system_id
    };
};

const deleteDocumentationFileUserInfoFailed = () => {
    return {
        type: actionTypes.DELETE_DOCUMENTATIONFILEUSERINFOS_FAILED
    };
};


export const deleteSingleDocumentationFileUserInfo = (documentationFileUserInfoId) => deleteDocumentationFileUserInfo(documentationFileUserInfoId, 'document')

export const deleteDocumentationFileUserInfo= (documentationFileUserInfoId, deletionType) => {
    const url = '/api/documentation_file_user_infos/' + documentationFileUserInfoId + '?deletionType=' + deletionType;
    return dispatch => {
        dispatch( deleteDocumentationFileUserInfoStart() );
        return axiosProtected.delete( url )
            .then( response => {
               dispatch(deleteDocumentationFileUserInfoSuccess(documentationFileUserInfoId));
            } )
            .catch( error => {
                dispatch(deleteDocumentationFileUserInfoFailed());
            } );
    };
};

export const deleteDocumentationFileUserInfoInProductSystem = (productSystemId) => {
    const url = '/api/documentation_file_user_infos/' + productSystemId + '?deletionType=productsystem';
    return dispatch => {
        dispatch( deleteDocumentationFileUserInfoStart() );
        return axiosProtected.delete( url )
            .then( response => {
               dispatch(deleteDocumentationFileUserInfoInProductSystemSuccess(productSystemId));
            } )
            .catch( error => {
                dispatch(deleteDocumentationFileUserInfoFailed());
            } );
    };
};




const deleteAllDocumentationFileUserInfoStart = ( product_system_id) => {
    return {
        type: actionTypes.DELETE_ALL_DOCUMENTATIONFILEUSERINFOS_START
    };
};

const deleteAllDocumentationFileUserInfoSuccess = ( product_system_id) => {
    return {
        type: actionTypes.DELETE_ALL_DOCUMENTATIONFILEUSERINFOS_SUCCESS
    };
};

const deleteAllDocumentationFileUserInfoFailed = () => {
    return {
        type: actionTypes.DELETE_ALL_DOCUMENTATIONFILEUSERINFOS_FAILED
    };
};


export const deleteAllDocumentationFileUserInfo = () => {
    const url = '/api/documentation_file_user_infos/xxx?deletionType=all';
    return dispatch => {
        dispatch( deleteAllDocumentationFileUserInfoStart() );
        return axiosProtected.delete( url )
            .then( response => {
               dispatch(deleteAllDocumentationFileUserInfoSuccess());
            } )
            .catch( error => {
                dispatch(deleteAllDocumentationFileUserInfoFailed());
            } );
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/documentation_file_user_infos.js